<template>
    <div class="relative">
        <div class="close absolute top-0 right-0 p-4">
            <button data-ec-close-info type="button" class="title hover:opacity-50 cursor-pointer">
                <XIcon class="h-8 w-8" />
            </button>
        </div>

        <div class="space-y-16 relative ct-bg-1 pt-16 pb-32 overflow-hidden">
            <InfoPoint
                :point="1"
                :title="
                    $l({
                        en: 'Cookie consent on the website with easycookie',
                        pl: 'Zgoda na ciasteczka na stronie z easycookie',
                    })
                "
                videoId="3SzqYH9zMmU"
            >
                <p class="body-text">
                    {{
                        $l({
                            en: "Insert the easycookie script into the HEAD section of your page.",
                            pl: "W sekcji HEAD swojej strony wklej link skryptu easycookie. ",
                        })
                    }}
                </p>
                <p class="body-text">
                    {{
                        $l({
                            en: "And .... that's it! Cookie notification will appear on your page. ",
                            pl: "I .... już! Na Twojej stronie pojawi się komunikat o zgodzie na ciasteczka.",
                        })
                    }}
                </p>
                <p class="body-text">
                    {{
                        $l({
                            en: "You can of course customize the style and content.",
                            pl: "Możesz oczywiście dostosować stylistykę i treści. ",
                        })
                    }}
                </p>
            </InfoPoint>
            <InfoPoint
                :point="2"
                :title="
                    $l({
                        en: 'Easycookie integration with GTM to collect consents',
                        pl: 'Integracja easycookie z GTM w celu zbierania zgód',
                    })
                "
                videoId="AbpuceuI4gQ"
            >
                <p class="body-text">
                    {{
                        $l({
                            en: "If you use GTM, you can easily integrate it with easycookie. Just choose the option in the Data management panel",
                            pl: "Jeśli używasz GTM, możesz łatwo zintegrować go z easycookie. Wystarczy wybrać opcję w panelu Zarządzenie danymi",
                        })
                    }}
                </p>
                <p class="body-text">
                    {{
                        $l({
                            en: "GTM will be informed about the consent given to:",
                            pl: "GTM zostanie poinformowany o wyrażeniu zgody na:",
                        })
                    }}
                </p>
                <ul class="body-text">
                    <li>ad_storage</li>
                    <li>ad_user_data</li>
                    <li>ad_personalization</li>
                    <li>analytics_storage</li>
                    <li>functionality_storage</li>
                    <li>personalization_storage</li>
                    <li>security_storage</li>
                </ul>
            </InfoPoint>
            <InfoPoint
                :point="3"
                :title="
                    $l({
                        en: 'Blocking own scripts in easycookie',
                        pl: 'Blokowanie własnych skryptów w easycookie',
                    })
                "
                videoId="Y2tIVpNs_LQ"
            >
                <p class="body-text">
                    {{
                        $l({
                            en: "If you want the scripts to be blocked until the user agrees to them, just add the appropriate attribute to them:",
                            pl: "Jeśli chcesz by skrypty były blokowane do czasu aż użytkownik wyrazi na nie zgodę wystarczy że dodasz do nich odpowiedni atrybut:",
                        })
                    }}
                </p>
                <ul class="body-text">
                    <li v-for="type in consentTypesWithoutStrict" :key="type">
                        {{ defaultTypes[type].name }} -
                        <span class="highlight">data-easycookie-{{ type }}</span>
                    </li>
                </ul>
            </InfoPoint>

            <InfoPoint
                :point="4"
                :title="
                    $l({
                        en: 'Generating a list of consents for easycookie',
                        pl: 'Generowanie listy zgód dla easycookie',
                    })
                "
                videoId="F6gJ__0FDKg"
            >
                <p class="body-text">
                    {{
                        $l({
                            en: "GTM will be informed about the consent given in particular to:",
                            pl: "easycookie pozwala stworzyć listę zgód jakie udzielili użytkownicy Twojej strony, wraz z datą, id, IP i innymi danymi.",
                        })
                    }}
                </p>
                <p class="body-text">
                    {{
                        $l({
                            en: "To do this, just select the option in the Data transfer panel, and then you will receive a link to the google sheets sheet, which will be available to you in the event of a control",
                            pl: "Po wybraniu tej opcji w panelu Przesyłanie danych otrzymasz link do arkusza google sheets, który będzie dla Ciebie dostępny w wypadku kontroli",
                        })
                    }}
                </p>
            </InfoPoint>
        </div>
    </div>
</template>

<script>
import { XIcon } from "@easy/ui/icons";
import { mapMutations } from "vuex";
import InfoPoint from "./InfoPoint.vue";
import { cookiesService } from "@/apps/cookie/services/cookies.service";

export default {
    name: "CookieInfo",
    data() {
        return {
            consentTypes: cookiesService.getConsentTypes(),
        };
    },
    computed: {
        defaultTypes() {
            return cookiesService.getDefaultTypes();
        },
        consentTypesWithoutStrict() {
            return this.consentTypes.filter((type) => type !== "strict");
        },
    },
    components: {
        XIcon,
        InfoPoint,
    },
    methods: {
        ...mapMutations(["setView"]),
    },
};
</script>

<style lang="scss" scoped>
ul {
    list-style-type: none;
}
li {
    position: relative;
    margin: 4px 0px;
    &:before {
        content: "";
        position: absolute;
        left: -20px;
        top: 10px;
        display: block;
        width: 8px;
        height: 8px;
        background-color: #f99f07;
        border-radius: 100%;
    }
}
.highlight_grey {
    background-color: #96a1a3;
    color: white;
    padding: 2px 4px;
}
.highlight {
    background-color: #f99f07;
    color: white;
    padding: 2px 4px;
}
</style>
